(function () {
  'use strict';

  var DEBOUNCE_MS = 400;
  var debounceTimer = null;
  var activeFetch = null;

  function getForm() {
    return document.getElementById('CollectionFiltersForm');
  }

  function getSection() {
    var form = getForm();
    if (!form) return null;
    return document.getElementById('CollectionSection-' + form.dataset.sectionId);
  }

  function buildUrl() {
    var form = getForm();
    var params = new URLSearchParams();
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function openFilters() {
    var section = getSection();
    if (!section) return [];
    var open = [];
    section.querySelectorAll('details.saha-filter[open]').forEach(function (d) {
      open.push(d.dataset.filterName);
    });
    return open;
  }

  function restoreOpenFilters(names) {
    var section = getSection();
    if (!section) return;
    names.forEach(function (name) {
      var d = section.querySelector('details.saha-filter[data-filter-name="' + name + '"]');
      if (d) d.setAttribute('open', '');
    });
  }

  function render(url) {
    var form = getForm();
    var section = getSection();
    if (!form || !section) {
      window.location.href = url;
      return;
    }
    var sectionId = form.dataset.sectionId;
    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    section.classList.add('is-loading');
    var wasOpen = openFilters();

    if (activeFetch) activeFetch.abort();
    activeFetch = new AbortController();

    fetch(fetchUrl.toString(), { signal: activeFetch.signal })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CollectionSection-' + sectionId);
        if (fresh) {
          section.replaceWith(fresh);
          restoreOpenFilters(wasOpen);
          // Re-trigger fade-in animations if theme uses them
          fresh.querySelectorAll('[data-fade]').forEach(function (el) {
            el.classList.add('is-visible');
          });
        }
        window.history.replaceState({}, '', url);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') window.location.href = url;
      });
  }

  function scheduleRender() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      render(buildUrl());
    }, DEBOUNCE_MS);
  }

  // Delegated listeners survive section replacement
  document.addEventListener('change', function (e) {
    var form = getForm();
    if (!form || !form.contains(e.target)) return;
    scheduleRender();
  });

  document.addEventListener('submit', function (e) {
    var form = getForm();
    if (form && e.target === form) {
      e.preventDefault();
      clearTimeout(debounceTimer);
      render(buildUrl());
    }
  });

  document.addEventListener('click', function (e) {
    var sortOption = e.target.closest('[data-sort-value]');
    if (sortOption) {
      var form = getForm();
      var input = form && form.querySelector('[data-sort-input]');
      if (input) {
        input.value = sortOption.dataset.sortValue;
        var dropdown = sortOption.closest('details');
        if (dropdown) dropdown.removeAttribute('open');
        clearTimeout(debounceTimer);
        render(buildUrl());
      }
      return;
    }

    var link = e.target.closest('[data-filter-remove]');
    if (link) {
      e.preventDefault();
      clearTimeout(debounceTimer);
      render(link.getAttribute('href'));
      return;
    }
    // Close open filter dropdowns when clicking outside
    var section = getSection();
    if (!section) return;
    if (!e.target.closest('details.saha-filter')) {
      section.querySelectorAll('details.saha-filter[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
    } else {
      var current = e.target.closest('details.saha-filter');
      section.querySelectorAll('details.saha-filter[open]').forEach(function (d) {
        if (d !== current) d.removeAttribute('open');
      });
    }
  });
})();
